<template>
  <div class="wrapper">
    <h1 class="headline mb-12">Log in</h1>

    <form @submit.prevent="submit">
      <v-text-field label="Email" outlined type="email" v-model="email" :error="!!emailError"></v-text-field>

      <v-text-field
        label="Password"
        type="password"
        outlined
        v-model="password"
        :error-messages="emailError"
      ></v-text-field>

      <v-btn
        depressed
        x-large
        class="align-self-center"
        :loading="loading"
        :disabled="!email || !password"
        type="submit"
      >Login</v-btn>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: "",
      emailError: null,
      loading: false
    };
  },
  methods: {
    ...mapActions(["login"]),
    submit() {
      this.emailError = null;
      this.loading = true;

      this.login({ email: this.email, password: this.password })
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/" });
        })
        .catch(() => {
          this.loading = false;
          this.emailError = "Wrong credentials";
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

form {
  width: 75vw;
  display: flex;
  flex-direction: column;
}
</style>